import GhostBar from "./GhostBar";

const GhostTransactionCard = () => {
  return (
    <div className="urt-card" style={{ cursor: "default" }}>
      {/* Container for the Top Row (Icon + Name + Amount) */}
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          alignItems: "center",
        }}
      >
        {/* Left side: Icon + Text Stack (70%) */}
        <div
          style={{
            display: "flex",
            gap: "10px",
            width: "70%",
            alignItems: "center",
          }}
        >
          <GhostBar
            width="40px"
            height="40px"
            circle
            className="urt-card-icon"
          />
          <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
            <GhostBar width="100px" height="14px" /> {/* Merchant Name */}
            <GhostBar width="60px" height="10px" /> {/* Date */}
          </div>
        </div>

        {/* Right side: Amount (30%) */}
        <div
          style={{ display: "flex", justifyContent: "flex-end", width: "30%" }}
        >
          <GhostBar width="55px" height="18px" />
        </div>
      </div>

      {/* Bottom section: Category (Mirroring the real card's bottom div) */}
      <div
        style={{
          padding: "4px 8px",
          borderRadius: "50px",
          width: "fit-content",
          background: "#C4C5C7",
        }}
      >
        <GhostBar width="70px" height="12px" />
      </div>
    </div>
  );
};

export default GhostTransactionCard;
